import { CommonModule } from '@angular/common';
import { Component, OnInit, inject, signal } from '@angular/core';
import {
    MatDialogActions,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle,
    MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { ChatConversation } from '../documentation-chat-dialog/documentation-chat';
import { ChatWindowComponent } from '../documentation-chat-dialog/chat-window/chat-window.component';
import { BackendApiService } from '../../../services/backend-api.service';
import { HttpParams } from '@angular/common/http';
import { NotificationService } from '../../../services/notification.service';
import { PhitoObjectApi } from '../../../services/phito-object';

export class DocumentationChatSimpleDialogInput { }

export class DocumentationChatSimpleDialogResult {
    constructor(public readonly confirmed: boolean) { }
}

@Component({
    selector: 'phito-documentation-chat-simple-dialog',
    standalone: true,
    imports: [
        CommonModule,
        MatDialogActions,
        MatDialogTitle,
        MatDialogContent,
        MatButton,
        ChatWindowComponent,
    ],
    templateUrl: './documentation-chat-simple-dialog.component.html',
    styleUrls: ['./documentation-chat-simple-dialog.component.scss'],
})
export class DocumentationChatSimpleDialogComponent implements OnInit {

    private dialogRef = inject<MatDialogRef<DocumentationChatSimpleDialogComponent>>(MatDialogRef);
    private api = inject(BackendApiService);
    private notificationService = inject(NotificationService);

    data = inject<DocumentationChatSimpleDialogInput>(MAT_DIALOG_DATA, { optional: true });

    conversation = signal<ChatConversation>(undefined);

    ngOnInit(): void {
        let p = new HttpParams();
        p = p.append('orderby', 'createdAt::desc');
        p = p.append('limit', 1);
        this.api.getAll<ChatConversation>('conversations', p).subscribe({
            next: (response: PhitoObjectApi<ChatConversation>) => {
                if (response.totalCount > 0) {
                    this.conversation.set(response.data[0]);
                } else {
                    this.newChat();
                }
            },
            error: err => {
                this.notificationService.errorMessageGet('Fehler!', err, p);
                this.newChat();
            }
        });
    }

    close(): void {
        this.dialogRef.close(new DocumentationChatSimpleDialogResult(false));
    }

    newChat(): void {
        this.conversation.set(new ChatConversation());
    }


}
